import React, { ReactNode, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import css from './index.module.css';

interface Props {
  text: string | ReactNode;
  short?: string | ReactNode;
}

export default function InfoBlock({ text, short }: Props) {
  const { t } = useTranslation();
  const [isOpened, setIsOpened] = useState(false);

  const toggle = useCallback(() => {
    setIsOpened((opened) => !opened);
  }, [setIsOpened]);

  return (
    <div className={css['container']}>
      {isOpened ? (
        <>
          {text}
          <span className={css['toggle']} onClick={toggle}>
            <FontAwesomeIcon icon={faChevronUp} className="text-accent" />
            {t('common.less')}
          </span>
        </>
      ) : (
        <>
          {short}
          <span className={css['toggle']} onClick={toggle}>
            <FontAwesomeIcon icon={faChevronDown} className="text-accent" />
            {t('common.read_more')}
          </span>
        </>
      )}
    </div>
  );
}
